import axios from "axios";

/**
 * 세션 기반 유저 정보 가져오기
 * @param {function} setUserInfo - 유저 상태 업데이트 함수
 * @param {function} [onError] - 에러 발생 시 호출할 선택적 콜백
 */
export const fetchSessionUser = (setUserInfo, onError) => {
    axios.get(`${process.env.REACT_APP_SPRING_API_URL}/api/session-user`, { withCredentials: true })
        .then(res => {
            const user = res.data;
            if (!user || !user.username) {
                setUserInfo(null); // 로그인 상태 아님
                return;
            }
            setUserInfo(user);
        })
        .catch(err => {
            console.error("초기 유저 정보 불러오기 실패:", err);
            setUserInfo(null);
            if (onError) onError(err);
        });
};
